const translations = {
  ru: {
    navLabel: "Основная навигация",
    localeLabel: "Выбор языка",
    common: {
      nav: {
        about: { label: "Главная", short: "Главная", aria: "Главная" },
        education: {
          label: "Обо мне",
          short: "Обо мне",
          aria: "Обо мне",
        },
        impressum: {
          label: "Реквизиты",
          short: "Рекв.",
          aria: "Реквизиты",
        },
        privacy: {
          label: "Данные",
          short: "Данные",
          aria: "Защита данных",
        },
      },
      footer: {
        tagline: "Психологическое консультирование онлайн",
        impressum: "Реквизиты",
        privacy: "Защита данных",
      },
    },
    pages: {
      home: {
        title: "Психологическое консультирование | Хадия Хазамова",
        items: [
          [".eyebrow", "Психолог онлайн"],
          [".hero h1", "Психологическое консультирование"],
          [
            ".hero__lede",
            "Меня зовут Хадия Хазамова. Я магистр психологии, системный семейный терапевт и член Немецкой ассоциации психотерапевтов (DPtV). В настоящее время прохожу обучение по программе Psychologische Psychotherapeutin (Systemische Therapie) в GST Berlin GmbH.",
          ],
          ['.hero__actions .button[href*="t.me"]', "Записаться в Telegram"],
          ['.hero__actions .button-secondary', "С чем я работаю"],
          ['#about .section-heading h2', "Как я работаю"],
          [
            '#about .section-intro',
            "В консультации для меня важны ясность, уважение к вашему темпу и поиск устойчивых опор, а не быстрых универсальных ответов.",
          ],
          [
            '#about .about-copy p:nth-child(1)',
            "Я опираюсь на системный подход, который помогает рассматривать трудности не изолированно, а в контексте жизненной истории человека, его отношений, семьи и среды.",
          ],
          [
            '#about .about-copy p:nth-child(2)',
            "На встречах мы исследуем сложившиеся способы взаимодействия, внутренние конфликты и ресурсы, чтобы найти решения, которые будут подходить именно вам.",
          ],
          ['#about .detail-panel h3', "Формат"],
          ['#about .detail-list li:nth-child(1)', "Онлайн-консультации в удобное время"],
          ['#about .detail-list li:nth-child(2)', "Индивидуальная и парная работа"],
          ['#about .detail-list li:nth-child(3)', "Спокойный, структурный и бережный диалог"],
          ['#services .section-heading h2', "Услуги"],
          [
            '#services .section-intro',
            "Работа строится вокруг вашего запроса, но с опорой на понятные рамки, время и согласованный формат взаимодействия.",
          ],
          ['#services .offer-card:nth-child(1) h3', "Индивидуальное консультирование"],
          ['#services .offer-card:nth-child(1) li:nth-child(1)', "Личные кризисы и поиск нового направления"],
          ['#services .offer-card:nth-child(1) li:nth-child(2)', "Внутренние конфликты и эмоциональная перегрузка"],
          ['#services .offer-card:nth-child(1) li:nth-child(3)', "Адаптация к новой стране, городу или роли"],
          ['#services .offer-card:nth-child(1) .offer-price', "90 евро / 60 минут"],
          ['#services .offer-card:nth-child(2) h3', "Парное консультирование"],
          ['#services .offer-card:nth-child(2) li:nth-child(1)', "Повторяющиеся конфликты и дистанция в отношениях"],
          ['#services .offer-card:nth-child(2) li:nth-child(2)', "Распределение ролей, границ и ответственности"],
          ['#services .offer-card:nth-child(2) li:nth-child(3)', "Кризисы семьи и изменение жизненного уклада"],
          ['#services .offer-card:nth-child(2) .offer-price', "140 евро / 90 минут"],
          ['#topics .section-heading h2', "С какими запросами можно обратиться"],
          [
            '#topics .section-intro',
            "Ниже представлены основные темы, с которыми я работаю. Если вы не нашли среди них свой запрос, это не означает, что ему нет места в консультации.",
          ],
          ['#topics .topic-card:nth-child(1) h3', "Самоидентичность"],
          ['#topics .topic-card:nth-child(1) p', "Когда прежние ориентиры перестают работать, а новые ещё не сформировались."],
          ['#topics .topic-card:nth-child(1) li:nth-child(1)', "Знакомство с собой и своими потребностями"],
          ['#topics .topic-card:nth-child(1) li:nth-child(2)', "Поиск ценностей, внутренних опор и жизненного направления"],
          ['#topics .topic-card:nth-child(1) li:nth-child(3)', "Возрастные и жизненные кризисы"],
          ['#topics .topic-card:nth-child(1) li:nth-child(4)', "Экзистенциальные и духовные вопросы"],
          ['#topics .topic-card:nth-child(1) li:nth-child(5)', "Внутриличностные конфликты"],
          ['#topics .topic-card:nth-child(1) li:nth-child(6)', "Переосмысление себя и своего жизненного пути"],
          ['#topics .topic-card:nth-child(1) li:nth-child(7)', "Ощущение потери себя в отношениях или браке"],
          ['#topics .topic-card:nth-child(1) li:nth-child(8)', "Возвращение к своим желаниям, интересам и собственной идентичности"],
          ['#topics .topic-card:nth-child(1) li:nth-child(9)', "Неуверенность в себе и зависимость от чужой оценки"],
          ['#topics .topic-card:nth-child(1) li:nth-child(10)', "Поиск внутренней опоры и устойчивости"],
          ['#topics .topic-card:nth-child(2) h3', "Иммиграция и адаптация"],
          ['#topics .topic-card:nth-child(2) p', "Когда переезд меняет привычную жизнь, отношения, ощущение себя и своего места в мире."],
          ['#topics .topic-card:nth-child(2) li:nth-child(1)', "Адаптация к жизни в новой стране"],
          ['#topics .topic-card:nth-child(2) li:nth-child(2)', "Поиск своего места в новой культуре"],
          ['#topics .topic-card:nth-child(2) li:nth-child(3)', "Чувство одиночества и потеря привычного круга общения"],
          ['#topics .topic-card:nth-child(2) li:nth-child(4)', "Языковой барьер и связанные с ним переживания"],
          ['#topics .topic-card:nth-child(2) li:nth-child(5)', "Изменение семейных ролей после переезда"],
          ['#topics .topic-card:nth-child(2) li:nth-child(6)', "Кризис идентичности и ощущение «я уже не там, но ещё не здесь»"],
          ['#topics .topic-card:nth-child(2) li:nth-child(7)', "Тревога, неопределённость и сложности интеграции"],
          ['#topics .topic-card:nth-child(2) li:nth-child(8)', "Поиск нового чувства дома при сохранении связи со своими корнями"],
          ['#topics .topic-card:nth-child(3) h3', "Материнство и родительство"],
          ['#topics .topic-card:nth-child(3) p', "Когда меняются роли, возрастает нагрузка и возникает необходимость найти более устойчивый способ быть в контакте с собой и близкими."],
          ['#topics .topic-card:nth-child(3) li:nth-child(1)', "Адаптация к материнству"],
          ['#topics .topic-card:nth-child(3) li:nth-child(2)', "Совмещение разных жизненных ролей"],
          ['#topics .topic-card:nth-child(3) li:nth-child(3)', "Выход из декрета и возвращение к профессиональной деятельности"],
          ['#topics .topic-card:nth-child(3) li:nth-child(4)', "Сложности родительства и эмоциональное выгорание"],
          ['#topics .topic-card:nth-child(3) li:nth-child(5)', "Понимание возрастных особенностей и потребностей детей"],
          ['#topics .topic-card:nth-child(3) li:nth-child(6)', "Поиск новых стратегий взаимодействия и воспитания"],
          ['#topics .topic-card:nth-child(3) li:nth-child(7)', "Поиск баланса между заботой о других и заботой о себе"],
          ['#topics .topic-card:nth-child(4) h3', "Отношения и семейные кризисы"],
          ['#topics .topic-card:nth-child(4) p', "Когда в отношениях появляются конфликты, дистанция, изменения или необходимость заново выстраивать контакт."],
          ['#topics .topic-card:nth-child(4) li:nth-child(1)', "Конфликты в паре и семье"],
          ['#topics .topic-card:nth-child(4) li:nth-child(2)', "Семейные кризисы и изменения структуры семьи"],
          ['#topics .topic-card:nth-child(4) li:nth-child(3)', "Личные границы, роли и распределение ответственности"],
          ['#topics .topic-card:nth-child(4) li:nth-child(4)', "Сепарация во взрослом возрасте"],
          ['#topics .topic-card:nth-child(4) li:nth-child(5)', "Созависимые отношения"],
          ['#topics .topic-card:nth-child(4) li:nth-child(6)', "Развод, расставание и завершение отношений"],
          ['#topics .topic-card:nth-child(4) li:nth-child(7)', "Горе, утрата и адаптация к новой жизненной реальности"],
          ['#topics .topic-card:nth-child(4) li:nth-child(8)', "Изменение себя и своих потребностей внутри длительных отношений"],
          ['#topics .topic-card:nth-child(4) li:nth-child(9)', "Поиск более живого и равноправного контакта в паре"],
          ['.quote-card p', "Если вам откликается такой подход, буду рада сопровождать вас в этом процессе."],
          ['#contact .section-heading h2', "Запись и контакты"],
          [
            '#contact .section-intro',
            "Для записи напишите в Telegram. Там мы согласуем удобное время и коротко обсудим ваш запрос.",
          ],
          ['#contact .contact-card:nth-child(1) h3', "Telegram"],
          ['#contact .contact-card:nth-child(1) p', 'Основной способ связи: <a target="_blank" rel="noreferrer" href="https://t.me/hadyahazam">@hadyahazam</a>'],
          ['#contact .contact-card:nth-child(2) h3', "E-Mail"],
          ['#contact .contact-card:nth-child(2) p', 'Для организационных вопросов: <a href="mailto:hadya.hazam@gmail.com">hadya.hazam@gmail.com</a>'],
          ['#contact .contact-card:nth-child(3) h3', "Следующий шаг"],
          ['#contact .contact-card:nth-child(3) p', "Напишите несколько слов о том, с чем хотите прийти в работу, и я предложу варианты времени."],
          ['#contact .hero__actions .button', "Написать в Telegram"],
        ],
      },
      education: {
        title: "Психологическое консультирование | Образование",
        items: [
          ['.section-card:nth-child(1) .eyebrow', "Образование"],
          ['.section-card:nth-child(1) .section-heading h2', "Обо мне"],
          ['.section-card:nth-child(1) .section-intro', "Магистр психологии и системный семейный терапевт, продолжающий профессиональное обучение и развитие терапевтической практики."],
          ['.section-card:nth-child(1) .about-copy p:nth-child(1)', "В настоящее время прохожу обучение по программе Psychologische Psychotherapeutin (Systemische Therapie) в GST Berlin GmbH."],
          ['.section-card:nth-child(1) .detail-panel h3', "Профессиональная квалификация"],
          ['.section-card:nth-child(1) .detail-list li:nth-child(1)', "Магистр психологии"],
          ['.section-card:nth-child(1) .detail-list li:nth-child(2)', "Системный семейный терапевт"],
          ['.section-card:nth-child(1) .detail-list li:nth-child(3)', "Психокоррекционный кинезиолог"],
          ['.section-card:nth-child(1) .detail-list li:nth-child(4)', "Psychologische Psychotherapeutin in Ausbildung"],
          ['.section-card:nth-child(2) .section-heading h2', "Образование"],
          ['.section-card:nth-child(2) .section-intro', "Основные этапы профессионального обучения и повышения квалификации."],
          ['.section-card:nth-child(2) .offer-card:nth-child(1) h3', "Актуальное обучение"],
          ['.section-card:nth-child(2) .offer-card:nth-child(1) li:nth-child(1)', "В настоящее время — обучение по программе Psychologische Psychotherapeutin (Systemische Therapie), GST Berlin GmbH"],
          ['.section-card:nth-child(2) .offer-card:nth-child(2) h3', "Высшее образование"],
          ['.section-card:nth-child(2) .offer-card:nth-child(2) li:nth-child(1)', "Магистр психологии, Дагестанский государственный университет, Махачкала, диплом с отличием, 2015"],
          ['.section-card:nth-child(2) .offer-card:nth-child(2) li:nth-child(2)', "Психолог. Преподаватель психологии, Дагестанский государственный университет, Махачкала, диплом с отличием, 2013"],
          ['.section-card:nth-child(2) .offer-card:nth-child(3) h3', "Профессиональная переподготовка и специализация"],
          ['.section-card:nth-child(2) .offer-card:nth-child(3) li:nth-child(1)', "Системная семейная терапия и консультирование, Институт повышения квалификации и переподготовки Международной академии психологических наук, Екатеринбург, 2022"],
          ['.section-card:nth-child(2) .offer-card:nth-child(3) li:nth-child(2)', "Системная семейная терапия и консультирование, Центр практической психологии «Простор», Екатеринбург, 2018–2020"],
          ['.section-card:nth-child(2) .offer-card:nth-child(4) h3', "Дополнительное образование"],
          ['.section-card:nth-child(2) .offer-card:nth-child(4) li:nth-child(1)', "Основы семейного консультирования, Первый университет профессора В. В. Макарова, Москва, 2022"],
          ['.section-card:nth-child(2) .offer-card:nth-child(4) li:nth-child(2)', "Нейрографика: Пользователь. Алгоритм снятия ограничений, Институт психологии творчества, 2020"],
          ['.section-card:nth-child(2) .offer-card:nth-child(4) li:nth-child(3)', "Психотерапевтическая кинезиология «Единый мозг. Концепция 3 в 1», Янгон, 2013"],
          ['.quote-card p', "Профессиональное развитие для меня — это не завершенный этап, а постоянная часть практики."],
        ],
      },
      impressum: {
        title: "Психологическое консультирование | Реквизиты",
        items: [
          ['.eyebrow', "Правовая информация"],
          ['h1', "Реквизиты"],
          ['.legal-card h2:nth-of-type(1)', "Ответственная за содержание согласно § 55 абз. 2 RStV и защита данных"],
          ['.legal-card h2:nth-of-type(2)', "Отказ от ответственности"],
          ['.legal-card h3:nth-of-type(1)', "Ответственность за содержание"],
          ['.legal-card h3:nth-of-type(2)', "Ответственность за ссылки"],
          ['.legal-card p:nth-of-type(9)', "Содержание наших страниц создавалось с максимально возможной тщательностью. Однако мы не можем гарантировать правильность, полноту и актуальность содержания. Как поставщик услуг, мы несем ответственность за собственное содержание этих страниц в соответствии с § 7 абз. 1 TMG и общими законами. Согласно §§ 8–10 TMG, мы не обязаны контролировать переданную или сохраненную чужую информацию либо искать обстоятельства, указывающие на противоправную деятельность. Обязанности по удалению или блокировке использования информации по общим законам остаются в силе. Ответственность в этом отношении возможна только с момента получения информации о конкретном нарушении. При получении сведений о таких нарушениях мы незамедлительно удалим соответствующее содержание."],
          ['.legal-card p:nth-of-type(10)', "Наше предложение содержит ссылки на внешние сайты третьих лиц, на содержание которых мы не имеем влияния. Поэтому мы не можем нести ответственность за это чужое содержание. За содержание связанных страниц всегда отвечает соответствующий поставщик или оператор сайта. На момент размещения ссылки связанные страницы были проверены на возможные нарушения закона. Противоправного содержания на момент размещения ссылки обнаружено не было. Постоянный контроль содержания связанных страниц без конкретных признаков нарушения закона нецелесообразен. При получении сведений о нарушениях мы незамедлительно удалим такие ссылки."],
        ],
      },
      privacy: {
        title: "Психологическое консультирование | Реквизиты и защита данных",
        items: [
          ['.eyebrow', "Защита данных"],
          ['h1', "Реквизиты и защита данных"],
          ['.legal-card h2:nth-of-type(1)', "Сведения согласно § 5 TMG"],
          ['.legal-card h2:nth-of-type(2)', "Ответственная за содержание согласно § 55 абз. 2 RStV и защита данных"],
          ['.legal-card h2:nth-of-type(3)', "Отказ от ответственности"],
          ['.legal-card h3:nth-of-type(1)', "Ответственность за содержание"],
          ['.legal-card h3:nth-of-type(2)', "Ответственность за ссылки"],
          ['.legal-card h2:nth-of-type(4)', "Политика конфиденциальности"],
          ['.legal-card h3:nth-of-type(3)', "1. Данные доступа и хостинг"],
          ['.legal-card p:nth-of-type(8)', "Содержание наших страниц создавалось с максимально возможной тщательностью. Однако мы не можем гарантировать правильность, полноту и актуальность содержания. Как поставщик услуг, мы несем ответственность за собственное содержание этих страниц в соответствии с § 7 абз. 1 TMG и общими законами. Согласно §§ 8–10 TMG, мы не обязаны контролировать переданную или сохраненную чужую информацию либо искать обстоятельства, указывающие на противоправную деятельность. Обязанности по удалению или блокировке использования информации по общим законам остаются в силе. Ответственность в этом отношении возможна только с момента получения информации о конкретном нарушении. При получении сведений о таких нарушениях мы незамедлительно удалим соответствующее содержание."],
          ['.legal-card p:nth-of-type(9)', "Наше предложение содержит ссылки на внешние сайты третьих лиц, на содержание которых мы не имеем влияния. Поэтому мы не можем нести ответственность за это чужое содержание. За содержание связанных страниц всегда отвечает соответствующий поставщик или оператор сайта. На момент размещения ссылки связанные страницы были проверены на возможные нарушения закона. Противоправного содержания на момент размещения ссылки обнаружено не было. Постоянный контроль содержания связанных страниц без конкретных признаков нарушения закона нецелесообразен. При получении сведений о нарушениях мы незамедлительно удалим такие ссылки."],
          ['.legal-card p:nth-of-type(11)', "Ответственным за обработку данных является:"],
          ['.legal-card p:nth-of-type(12)', "Мы рады вашему интересу к нашему сайту. Защита вашей частной жизни очень важна для нас. Ниже мы подробно информируем вас о работе с вашими данными."],
          ['.legal-card p:nth-of-type(13)', "Вы можете посещать наши веб-страницы, не сообщая персональные данные. При каждом обращении к веб-странице веб-сервер автоматически сохраняет так называемый server log file, который, например, содержит имя запрошенного файла, ваш IP-адрес, дату и время запроса, объем переданных данных и запрашивающего провайдера. Эти данные доступа используются исключительно для обеспечения бесперебойной работы сайта и улучшения нашего предложения. Это служит защите наших преобладающих законных интересов в корректном представлении предложения согласно Art. 6 Abs. 1 S. 1 lit. f DSGVO. Все данные доступа удаляются не позднее чем через семь дней после окончания вашего посещения сайта."],
        ],
      },
    },
  },
  de: {
    navLabel: "Hauptnavigation",
    localeLabel: "Sprache wählen",
    common: {
      nav: {
        about: { label: "Startseite", short: "Start", aria: "Startseite" },
        education: {
          label: "Über mich",
          short: "Über mich",
          aria: "Über mich",
        },
        impressum: {
          label: "Impressum",
          short: "Info",
          aria: "Impressum",
        },
        privacy: {
          label: "Datenschutz",
          short: "DSGVO",
          aria: "Datenschutz",
        },
      },
      footer: {
        tagline: "Online-psychologische Beratung",
        impressum: "Impressum",
        privacy: "Datenschutz",
      },
    },
    pages: {
      home: {
        title: "Psychologische Beratung | Khadiia Khazamova",
        items: [
          [".eyebrow", "Online-Psychologin"],
          [".hero h1", "Psychologische Beratung"],
          [
            ".hero__lede",
            "Mein Name ist Khadiia Khazamova. Ich habe einen Master in Psychologie und arbeite als systemische Familientherapeutin. Ich lebe und arbeite in Deutschland. In meiner Praxis arbeite ich auf der Grundlage des systemischen Ansatzes und biete Einzel- und Paarberatungen online an.",
          ],
          ['.hero__actions .button[href*="t.me"]', "Termin über Telegram"],
          ['.hero__actions .button-secondary', "Womit ich arbeite"],
          ['#about .section-heading h2', "Wie ich arbeite"],
          [
            '#about .section-intro',
            "In der Beratung sind mir Klarheit, Respekt für Ihr Tempo und die Suche nach tragfähigen Orientierungspunkten wichtiger als schnelle Universalantworten.",
          ],
          [
            '#about .about-copy p:nth-child(1)',
            "Ich arbeite auf der Grundlage eines systemischen Ansatzes, der hilft, Schwierigkeiten nicht isoliert, sondern im Kontext der Lebensgeschichte eines Menschen, seiner Beziehungen, seiner Familie und seines Umfelds zu betrachten.",
          ],
          [
            '#about .about-copy p:nth-child(2)',
            "In den Sitzungen untersuchen wir gewohnte Interaktionsmuster, innere Konflikte und Ressourcen, um Lösungen zu finden, die wirklich zu Ihnen passen.",
          ],
          ['#about .detail-panel h3', "Format"],
          ['#about .detail-list li:nth-child(1)', "Online-Beratung zu passenden Zeiten"],
          ['#about .detail-list li:nth-child(2)', "Einzel- und Paararbeit"],
          ['#about .detail-list li:nth-child(3)', "Ruhiger, strukturierter und achtsamer Dialog"],
          ['#services .section-heading h2', "Angebot"],
          [
            '#services .section-intro',
            "Die Arbeit orientiert sich an Ihrem Anliegen, bleibt aber in einem klaren Rahmen mit Zeitstruktur und abgestimmtem Format.",
          ],
          ['#services .offer-card:nth-child(1) h3', "Einzelberatung"],
          ['#services .offer-card:nth-child(1) li:nth-child(1)', "Persönliche Krisen und die Suche nach neuer Orientierung"],
          ['#services .offer-card:nth-child(1) li:nth-child(2)', "Innere Konflikte und emotionale Überlastung"],
          ['#services .offer-card:nth-child(1) li:nth-child(3)', "Anpassung an ein neues Land, eine neue Stadt oder Rolle"],
          ['#services .offer-card:nth-child(1) .offer-price', "90 Euro / 60 Minuten"],
          ['#services .offer-card:nth-child(2) h3', "Paarberatung"],
          ['#services .offer-card:nth-child(2) li:nth-child(1)', "Wiederkehrende Konflikte und Distanz in der Beziehung"],
          ['#services .offer-card:nth-child(2) li:nth-child(2)', "Rollen, Grenzen und Verantwortung"],
          ['#services .offer-card:nth-child(2) li:nth-child(3)', "Familienkrisen und Veränderungen im Lebensalltag"],
          ['#services .offer-card:nth-child(2) .offer-price', "140 Euro / 90 Minuten"],
          ['#topics .section-heading h2', "Womit ich arbeite"],
          [
            '#topics .section-intro',
            "Hier finden Sie zentrale Themen, mit denen ich arbeite. Wenn Sie Ihr Anliegen darin nicht wiederfinden, bedeutet das nicht, dass es in der Beratung keinen Platz hat.",
          ],
          ['#topics .topic-card:nth-child(1) h3', "Selbstidentität"],
          ['#topics .topic-card:nth-child(1) p', "Wenn frühere Orientierungspunkte nicht mehr tragen und neue noch nicht entstanden sind."],
          ['#topics .topic-card:nth-child(1) li:nth-child(1)', "Sich selbst und die eigenen Bedürfnisse kennenlernen"],
          ['#topics .topic-card:nth-child(1) li:nth-child(2)', "Werte, innere Stützen und Lebensrichtung finden"],
          ['#topics .topic-card:nth-child(1) li:nth-child(3)', "Alters- und Lebenskrisen"],
          ['#topics .topic-card:nth-child(1) li:nth-child(4)', "Existenzielle und spirituelle Fragen"],
          ['#topics .topic-card:nth-child(1) li:nth-child(5)', "Innere Konflikte"],
          ['#topics .topic-card:nth-child(1) li:nth-child(6)', "Sich selbst und den eigenen Lebensweg neu verstehen"],
          ['#topics .topic-card:nth-child(1) li:nth-child(7)', "Das Gefühl, sich in Beziehungen oder Ehe verloren zu haben"],
          ['#topics .topic-card:nth-child(1) li:nth-child(8)', "Zurückfinden zu eigenen Wünschen, Interessen und Identität"],
          ['#topics .topic-card:nth-child(1) li:nth-child(9)', "Unsicherheit und Abhängigkeit von fremder Bewertung"],
          ['#topics .topic-card:nth-child(1) li:nth-child(10)', "Innere Stabilität und Halt finden"],
          ['#topics .topic-card:nth-child(2) h3', "Migration und Anpassung"],
          ['#topics .topic-card:nth-child(2) p', "Wenn ein Umzug das gewohnte Leben, Beziehungen und das Gefühl für sich selbst und den eigenen Platz verändert."],
          ['#topics .topic-card:nth-child(2) li:nth-child(1)', "Anpassung an das Leben in einem neuen Land"],
          ['#topics .topic-card:nth-child(2) li:nth-child(2)', "Den eigenen Platz in einer neuen Kultur finden"],
          ['#topics .topic-card:nth-child(2) li:nth-child(3)', "Einsamkeit und Verlust des vertrauten sozialen Umfelds"],
          ['#topics .topic-card:nth-child(2) li:nth-child(4)', "Sprachbarriere und damit verbundene Belastungen"],
          ['#topics .topic-card:nth-child(2) li:nth-child(5)', "Veränderung familiärer Rollen nach dem Umzug"],
          ['#topics .topic-card:nth-child(2) li:nth-child(6)', "Identitätskrise und das Gefühl: nicht mehr dort, aber noch nicht hier"],
          ['#topics .topic-card:nth-child(2) li:nth-child(7)', "Angst, Unsicherheit und Schwierigkeiten bei der Integration"],
          ['#topics .topic-card:nth-child(2) li:nth-child(8)', "Ein neues Zuhausegefühl finden und die Verbindung zu den eigenen Wurzeln bewahren"],
          ['#topics .topic-card:nth-child(3) h3', "Mutterschaft und Elternschaft"],
          ['#topics .topic-card:nth-child(3) p', "Wenn sich Rollen verändern, Belastung wächst und ein stabilerer Kontakt zu sich selbst und den Nahestehenden wichtig wird."],
          ['#topics .topic-card:nth-child(3) li:nth-child(1)', "Anpassung an die Mutterschaft"],
          ['#topics .topic-card:nth-child(3) li:nth-child(2)', "Verschiedene Lebensrollen miteinander vereinbaren"],
          ['#topics .topic-card:nth-child(3) li:nth-child(3)', "Rückkehr aus der Elternzeit und zurück in den Beruf"],
          ['#topics .topic-card:nth-child(3) li:nth-child(4)', "Elterliche Belastung und emotionale Erschöpfung"],
          ['#topics .topic-card:nth-child(3) li:nth-child(5)', "Altersbesonderheiten und Bedürfnisse von Kindern verstehen"],
          ['#topics .topic-card:nth-child(3) li:nth-child(6)', "Neue Wege im Umgang und in der Erziehung finden"],
          ['#topics .topic-card:nth-child(3) li:nth-child(7)', "Balance zwischen Fürsorge für andere und Fürsorge für sich selbst"],
          ['#topics .topic-card:nth-child(4) h3', "Beziehungen und Familienkrisen"],
          ['#topics .topic-card:nth-child(4) p', "Wenn in Beziehungen Konflikte, Distanz, Veränderungen oder die Notwendigkeit entstehen, Kontakt neu aufzubauen."],
          ['#topics .topic-card:nth-child(4) li:nth-child(1)', "Konflikte in Paar und Familie"],
          ['#topics .topic-card:nth-child(4) li:nth-child(2)', "Familienkrisen und Veränderungen der Familienstruktur"],
          ['#topics .topic-card:nth-child(4) li:nth-child(3)', "Persönliche Grenzen, Rollen und Verantwortung"],
          ['#topics .topic-card:nth-child(4) li:nth-child(4)', "Ablösung im Erwachsenenalter"],
          ['#topics .topic-card:nth-child(4) li:nth-child(5)', "Co-abhängige Beziehungen"],
          ['#topics .topic-card:nth-child(4) li:nth-child(6)', "Scheidung, Trennung und Beziehungsabschluss"],
          ['#topics .topic-card:nth-child(4) li:nth-child(7)', "Trauer, Verlust und Anpassung an eine neue Lebensrealität"],
          ['#topics .topic-card:nth-child(4) li:nth-child(8)', "Sich selbst und die eigenen Bedürfnisse in langen Beziehungen verändern"],
          ['#topics .topic-card:nth-child(4) li:nth-child(9)', "Lebendigeren und gleichwertigeren Kontakt in der Paarbeziehung finden"],
          ['.quote-card p', "Wenn Ihnen dieser Ansatz nahe ist, begleite ich Sie gern in diesem Prozess."],
          ['#contact .section-heading h2', "Anmeldung und Kontakt"],
          [
            '#contact .section-intro',
            "Für eine Anmeldung schreiben Sie mir bei Telegram. Dort stimmen wir einen passenden Termin ab und besprechen kurz Ihr Anliegen.",
          ],
          ['#contact .contact-card:nth-child(1) h3', "Telegram"],
          ['#contact .contact-card:nth-child(1) p', 'Hauptweg für die Kontaktaufnahme: <a target="_blank" rel="noreferrer" href="https://t.me/hadyahazam">@hadyahazam</a>'],
          ['#contact .contact-card:nth-child(2) h3', "E-Mail"],
          ['#contact .contact-card:nth-child(2) p', 'Für organisatorische Fragen: <a href="mailto:hadya.hazam@gmail.com">hadya.hazam@gmail.com</a>'],
          ['#contact .contact-card:nth-child(3) h3', "Nächster Schritt"],
          ['#contact .contact-card:nth-child(3) p', "Schreiben Sie ein paar Sätze dazu, womit Sie in die Arbeit kommen möchten, und ich schlage passende Zeiten vor."],
          ['#contact .hero__actions .button', "Auf Telegram schreiben"],
        ],
      },
      education: {
        title: "Psychologische Beratung | Ausbildung",
        items: [
          ['.section-card:nth-child(1) .eyebrow', "Ausbildung"],
          ['.section-card:nth-child(1) .section-heading h2', "Über mich"],
          ['.section-card:nth-child(1) .section-intro', "Master in Psychologie und systemische Familientherapeutin, die ihre berufliche Ausbildung und therapeutische Praxis weiterentwickelt."],
          ['.section-card:nth-child(1) .about-copy p:nth-child(1)', "Derzeit absolviere ich die Ausbildung zur Psychologischen Psychotherapeutin (Systemische Therapie) bei GST Berlin GmbH."],
          ['.section-card:nth-child(1) .detail-panel h3', "Berufliche Qualifikation"],
          ['.section-card:nth-child(1) .detail-list li:nth-child(1)', "Master in Psychologie"],
          ['.section-card:nth-child(1) .detail-list li:nth-child(2)', "Systemische Familientherapeutin"],
          ['.section-card:nth-child(1) .detail-list li:nth-child(3)', "Psychokorrektive Kinesiologin"],
          ['.section-card:nth-child(1) .detail-list li:nth-child(4)', "Psychologische Psychotherapeutin in Ausbildung"],
          ['.section-card:nth-child(2) .section-heading h2', "Ausbildung"],
          ['.section-card:nth-child(2) .section-intro', "Wesentliche Stationen meiner beruflichen Ausbildung und Weiterbildung."],
          ['.section-card:nth-child(2) .offer-card:nth-child(1) h3', "Aktuelle Ausbildung"],
          ['.section-card:nth-child(2) .offer-card:nth-child(1) li:nth-child(1)', "Derzeit — Ausbildung zur Psychologischen Psychotherapeutin (Systemische Therapie), GST Berlin GmbH"],
          ['.section-card:nth-child(2) .offer-card:nth-child(2) h3', "Hochschulbildung"],
          ['.section-card:nth-child(2) .offer-card:nth-child(2) li:nth-child(1)', "Master in Psychologie, Staatliche Universität Dagestan, Machatschkala, Diplom mit Auszeichnung, 2015"],
          ['.section-card:nth-child(2) .offer-card:nth-child(2) li:nth-child(2)', "Psychologin. Dozentin für Psychologie, Staatliche Universität Dagestan, Machatschkala, Diplom mit Auszeichnung, 2013"],
          ['.section-card:nth-child(2) .offer-card:nth-child(3) h3', "Berufliche Umschulung und Spezialisierung"],
          ['.section-card:nth-child(2) .offer-card:nth-child(3) li:nth-child(1)', "Systemische Familientherapie und Beratung, Institut für Fortbildung und Umschulung der Internationalen Akademie der Psychologischen Wissenschaften, Jekaterinburg, 2022"],
          ['.section-card:nth-child(2) .offer-card:nth-child(3) li:nth-child(2)', "Systemische Familientherapie und Beratung, Zentrum für Praktische Psychologie „Prostor“, Jekaterinburg, 2018–2020"],
          ['.section-card:nth-child(2) .offer-card:nth-child(4) h3', "Zusätzliche Ausbildungen"],
          ['.section-card:nth-child(2) .offer-card:nth-child(4) li:nth-child(1)', "Grundlagen der Familienberatung, Erste Universität von Prof. W. W. Makarov, Moskau, 2022"],
          ['.section-card:nth-child(2) .offer-card:nth-child(4) li:nth-child(2)', "Neurographik: Anwenderin. Algorithmus zur Auflösung von Begrenzungen, Institut für Kreativitätspsychologie, 2020"],
          ['.section-card:nth-child(2) .offer-card:nth-child(4) li:nth-child(3)', "Psychotherapeutische Kinesiologie „One Brain. Three in One Concepts“, Yangon, 2013"],
          ['.quote-card p', "Berufliche Entwicklung ist für mich kein abgeschlossener Abschnitt, sondern ein fortlaufender Teil meiner Praxis."],
        ],
      },
      impressum: {
        title: "Psychologische Beratung | Impressum",
        items: [
          ['.eyebrow', "Rechtliche Informationen"],
          ['h1', "Impressum"],
          ['.legal-card h2:nth-of-type(1)', "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV und Datenschutzbeauftragter"],
          ['.legal-card h2:nth-of-type(2)', "Haftungsausschluss"],
          ['.legal-card h3:nth-of-type(1)', "Haftung für Inhalte"],
          ['.legal-card h3:nth-of-type(2)', "Haftung für Links"],
        ],
      },
      privacy: {
        title: "Psychologische Beratung | Impressum & Datenschutzbestimmungen",
        items: [
          ['.eyebrow', "Datenschutz"],
          ['h1', "Impressum & Datenschutzbestimmungen"],
          ['.legal-card h2:nth-of-type(1)', "Angaben gemäß § 5 TMG"],
          ['.legal-card h2:nth-of-type(2)', "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV und Datenschutzbeauftragter"],
          ['.legal-card h2:nth-of-type(3)', "Haftungsausschluss"],
          ['.legal-card h3:nth-of-type(1)', "Haftung für Inhalte"],
          ['.legal-card h3:nth-of-type(2)', "Haftung für Links"],
          ['.legal-card h2:nth-of-type(4)', "Datenschutzerklärung"],
          ['.legal-card h3:nth-of-type(3)', "1. Zugriffsdaten und Hosting"],
          ['.legal-card p:nth-of-type(11)', "Verantwortlicher für die Datenverarbeitung ist:"],
          ['.legal-card p:nth-of-type(12)', "Wir freuen uns über Ihr Interesse an unserer Webseite. Der Schutz Ihrer Privatsphäre ist für uns sehr wichtig. Nachstehend informieren wir Sie ausführlich über den Umgang mit Ihren Daten."],
        ],
      },
    },
  },
};

function setText(selector, value) {
  const element = document.querySelector(selector);
  if (element) element.innerHTML = value;
}

function applyCommon(locale) {
  const common = translations[locale].common;
  const nav = common.nav;
  const navMap = [
    ["/", nav.about],
    ["/education.html", nav.education],
    ["/impressum.html", nav.impressum],
    ["/datenshutz.html", nav.privacy],
  ];

  document.querySelector(".site-nav")?.setAttribute("aria-label", translations[locale].navLabel);
  document.querySelector(".locale-toggle")?.setAttribute("aria-label", translations[locale].localeLabel);

  navMap.forEach(([href, item]) => {
    const link = document.querySelector(`.site-nav__links a[href="${href}"]`);
    if (!link) return;
    const label = link.querySelector(".nav-label");
    link.setAttribute("aria-label", item.aria);
    if (label) {
      label.textContent = item.label;
      label.dataset.short = item.short;
    }
  });

  setText(".site-footer__inner > span:first-child", common.footer.tagline);
  setText('.site-footer__inner a[href="impressum.html"]', common.footer.impressum);
  setText('.site-footer__inner a[href="datenshutz.html"]', common.footer.privacy);
}

function applyPage(locale) {
  const page = document.body.dataset.page;
  const config = translations[locale].pages[page];
  if (!config) return;

  document.documentElement.lang = locale;
  document.title = config.title;
  config.items.forEach(([selector, value]) => setText(selector, value));
}

function setActiveLocale(locale) {
  document.querySelectorAll(".locale-toggle__button").forEach((button) => {
    button.classList.toggle("is-active", button.dataset.locale === locale);
  });
}

function detectLocale() {
  const stored = localStorage.getItem("site-locale");
  if (stored === "ru" || stored === "de") return stored;
  return navigator.language && navigator.language.toLowerCase().startsWith("de")
    ? "de"
    : "ru";
}

function applyLocale(locale) {
  applyCommon(locale);
  applyPage(locale);
  setActiveLocale(locale);
  localStorage.setItem("site-locale", locale);
}

document.addEventListener("DOMContentLoaded", () => {
  const locale = detectLocale();
  applyLocale(locale);

  document.querySelectorAll(".locale-toggle__button").forEach((button) => {
    button.addEventListener("click", () => {
      applyLocale(button.dataset.locale);
    });
  });
});
